<div [@routerTransition] class="margin-top-18px">
  <div class="row">

    <div class="columnbv4">
      <div class="position-fixed-bills border-right2 padding-right-5px height-100pe">
        <div class="card height-100pe">

          <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
            <div class="row margin-top10px margin-left-20px  nav-link-hand">
              <div class="col-md-10 padding-left-0px ">
                <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                  Purchase Indents
                </label>
              </div>

            </div>

            <div class="row margin-left-20px  nav-link-hand">
              <div (click)="DecrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                <a title="Previous" class="nav-link-hand">
                  <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
                </a>
              </div>


              <div class="col-md-4 col-sm-4 padding-left-5px padding-right-9px">
                <div class="date-form billing-calender">
                  <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px  data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                         (ngModelChange)="dataChanged($event)">

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>



              </div>
              <div (click)="IncrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                <a title="Next" class="nav-link-hand">
                  <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
                </a>
              </div>

              <div class="col-md-4 float-right">
                <button *canUserAccess="['HL_ER_7']" type="button" class="btn  btn-sm button-new-health2"
                        (click)="AddIndent()" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i>
                </button>
              </div>
            </div>


          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
            
            <div class="row margin-right-0px margin-left-0px">
              <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                <search-list [title]="searchTitle" [hideTitle]="1"></search-list>

              </div>
              <div class="col-md-2" hidden>
                <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a class="nav-link-hand education-navlink" tooltip="Edit">
                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                </a>

              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a class="nav-link-hand education-navlink" tooltip="Delete">
                  <span class="badge font-size-14">
                    <i class="far fa-trash-alt"></i>
                  </span>
                </a>
              </div>

            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde">
                <div *ngIf="isRequesting">

                  <div class="loader-text">
                    <div class="loader-text2">

                      <div class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <div class="margin-top-20px margin-left-5px">
                        <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                      </div>

                    </div>
                  </div>


                </div>
                <div>
                  <div class="row border-bottom row-for-scans2 margin-left16px nav-link-hand padding-bottom-6px"
                       (click)="Selectedpatient(l)" *ngFor="let l of CurrentPurchaseIndentsListController">
                    
                    <div class="col-md-10 margin-top-5px padding-right-0px padding-left-5px border-left-received">
                      <div class="row row-height-17px">
                        <div class="col-md-9">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.IndentNo}}</label>
                        </div>
                        <div class="col-md-3">
                          <div class="text-align-center">
                            <a data-toggle="tooltip" data-placement="bottom" title="Raised" *ngIf="l.IndentStatus=='RAISD'">
                              <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="" *ngIf="l.IndentStatus!='RAISD'">
                              <i class="fas fa-circle color-gray  nav-link-hand font-size-14">
                              </i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="row row-height-17px padding-top-2px">
                        <div class="col-md-8">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.RequestedByActorName}}</label>
                        </div>
                        <div class="col-md-4 padding-right-0px text-align-center">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.RequestDate | date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                      
                    </div>
                    
                  </div>
                </div>
                
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="columnbp4" *ngIf="billdetails1">
      <div class="col-md-12 padding-left-0px">
        <div class="card">
          <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px" id="header">
            <div class="row">

              <div class="col-md-6 padding-left-23px">
                <div class="row font-size-12px" *ngIf="CurrentPurchaseIndentsHeaderController">
                  <div class="col-md-5 text-align-left padding-right-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Indent No</label>
                  </div>:
                  <div class="col-md-6 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px ">{{CurrentPurchaseIndentsHeaderController.IndentNo}}</label>
                  </div>
                </div>
                <div class="row font-size-12px" *ngIf="CurrentPurchaseIndentsHeaderController">
                  <div class="col-md-5 text-align-left padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Indent ID </label>
                  </div>:
                  <div class="col-md-6 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">
                      {{CurrentPurchaseIndentsHeaderController.PurchaseIndentCode}}
                    </label>
                  </div>
                </div>
                <div class="row font-size-12px" *ngIf="CurrentPurchaseIndentsHeaderController">
                  <div class="col-md-5 text-align-left padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">IS Auto </label>
                  </div>:
                  <div class="col-md-6 padding-right-0px padding-left-10px" *ngIf="CurrentPurchaseIndentsHeaderController.AutoGenerated">
                    <i class="fas fa-check-circle color-icon-completed font-size-14"></i>
                  </div>
                </div>
                <div class="row font-size-12px" *ngIf="CurrentPurchaseIndentsHeaderController">
                  <div class="col-md-5 text-align-left padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">IS Closed </label>
                  </div>:
                  <div class="col-md-6 padding-right-0px padding-left-10px" *ngIf="CurrentPurchaseIndentsHeaderController.IsIndentClosed">
                    <i class="fas fa-check-circle color-icon-completed font-size-14"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-6  padding-right-0px">
                <div class="row font-size-12px" *ngIf="CurrentPurchaseIndentsHeaderController">
                  <div class="col-md-5 margin-left-auto text-align-right padding-right-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Requested Date </label>
                  </div>:
                  <div class="col-md-6 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px ">{{CurrentPurchaseIndentsHeaderController.RequestDate | date:'MMM-dd-yyyy'}}</label>
                  </div>
                </div>
                <div class="row font-size-12px" *ngIf="CurrentPurchaseIndentsHeaderController">
                  <div class="col-md-5 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Requested User </label>
                  </div>:
                  <div class="col-md-6 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">
                      {{CurrentPurchaseIndentsHeaderController.RequestedByActorName}}
                    </label>
                  </div>
                </div>
                <div class="row font-size-12px" *ngIf="CurrentPurchaseIndentsHeaderController">
                  <div class="col-md-5 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">From Store </label>
                  </div>:
                  <div class="col-md-6 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">
                      {{CurrentPurchaseIndentsHeaderController.FromStoreName}}
                    </label>
                  </div>
                </div>
                <div class="row font-size-12px" *ngIf="CurrentPurchaseIndentsHeaderController">
                  <div class="col-md-5 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Status </label>
                  </div>:
                  <div class="col-md-6 padding-right-0px padding-left-10px">
                    <a data-toggle="tooltip" data-placement="bottom" title="Raised" *ngIf="CurrentPurchaseIndentsHeaderController.IndentStatus=='RAISD'">
                      <i class="fas fa-check-circle color-icon-completed font-size-14"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="card-body padding-right-0px padding-top-0px padding-bottom-0px padding-left-0px">

            <div class="card">
              <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                <div class="row nav-link-hand margin-right-0px" id="edit-link">
                  <div class="col-md-3 padding-right-0px">
                    <label class="margin-bottom-0px font-size-16px font-weight-normal padding-left-10px">
                      Indent  Details
                    </label>
                  </div>
                  <div class="col-md-9  padding-right-3px">
                    <div class="row float-right">
                      <div class="col-md-12 margin-top-3px padding-left-0px padding-right-0px text-align-right">
                        <!--<div class="display-inline">
                          <button *canUserAccess="['HL_ER_8']" type="button"
                                  (click)="Indentedit()"
                                  class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Edit">
                          <i class="fas fa-pencil-alt"></i>
                          </button>
                        </div>-->
                        <!--<div class="display-inline">
                          <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="opbill()">
                            <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A4
                          </button>
                        </div>
                        <div class="display-inline">
                          <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="A5opbill()">
                            <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A5
                          </button>
                        </div>-->
                     </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class=" padding-lrt " data-ps-id="dfsfsde">
                <div class="card-body">
                  <div id="items">
                    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                      <div class="accordion" id="accordionExampleone">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                            <div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Line Items
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExampleone">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="table-component">
                                    <div class="table-responsive overflow-x">


                                      <table class="table table-striped"
                                             cols="auto,2*,*,*,*,*,*,*">

                                        <thead class="">
                                          <tr>

                                            <th class="min-width-24px padding-bottom-4px padding-top-4px">
                                              #
                                            </th>


                                            <th class="padding-top-4px padding-bottom-4px">
                                              Material Code
                                            </th>
                                            <th class="text-align-left padding-right-0px padding-top-4px padding-bottom-4px">
                                              Material Description
                                            </th>
                                            <th class="text-align-right padding-right-0px padding-top-4px padding-bottom-4px">
                                              QTY
                                            </th>
                                            <th class="text-align-left padding-right-0px padding-top-4px padding-bottom-4px">
                                              
                                            </th>

                                          </tr>
                                        </thead>

                                        <tbody class="table-body">
                                          <tr *ngFor="let l of CurrentPurchaseIndentItemsController;let RowIndex = index">


                                            <td class="td-padding-tb">
                                              {{RowIndex+1}}
                                            </td>
                                            <td class=" td-padding-tb">
                                              {{l.MaterialCode}}
                                            </td>
                                            <td class="text-align-left td-padding-tb padding-right-0px">
                                              {{l.MaterialDescription}}
                                            </td>
                                            <td class="text-align-right td-padding-tb  padding-right-7px">
                                              {{l.Quantity}}
                                            </td>
                                            <td class="text-align-left td-padding-tb  padding-right-7px">
                                              {{l.UOM}}
                                            </td>

                                          </tr>

                                        </tbody>



                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>



                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div id="Receipts">
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExampleThr">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThr">
                            <div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThr" aria-expanded="true" aria-controls="collapseThr">
                                    Remarks
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseThr" class="collapse show" aria-labelledby="headingThr" data-parent="#accordionExampleThr">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row padding-top-3px">
                                <div class="col-md-11 padding-right-0px margin-left-10px" *ngIf="CurrentPurchaseIndentsHeaderController">
                                  <textarea class="form-control3 size-2 width-inherit"
                                            name="CurrentPurchaseIndentsHeaderController.Remarks"
                                            [(ngModel)]="CurrentPurchaseIndentsHeaderController.Remarks"
                                            rows="2" placeholder="Remarks"></textarea>
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="columnbp3 background-white" *ngIf="billdetails2">

      <div class="position-fixed-Activities3">

      </div>
      
    </div>


  </div>
</div>

